// extracted by mini-css-extract-plugin
module.exports = {"form":"AddBlog_form__3O7JT","spacing":"AddBlog_spacing__2aAzF","widthHalfPage":"AddBlog_widthHalfPage__3hP3d"};